import { styled } from "@mui/material/styles";

export const StyledContainer = styled("div")(() => ({
  height: "100%",
}));
